import { OtherConcerns } from "./v1";

export const otherConcernsOptions = Object.entries(OtherConcerns)
	.filter(([, value]) => {
		return isNaN(Number(value));
	})
	.map(([value, label]) => {
		return { value, label };
	});
